<script>
import WebLinkMixin from '@/mixins/weblink'
import IconPlay from '@/components/IconPlay.vue'
import vueSignature from 'vue-signature'

import { SELLING_REGIONS, OPPORTUNITY_TYPES_IDS } from '@/constants'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'WebLinkLuxuryGold',
  mixins: [WebLinkMixin],
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      isModalBookMyGroupSuccessToggle: false,
      isModalBookMyGroupToggle: false,
      modal: 0,
      signatureBoolean: true,
      signatureName: false,
      signaturePayment: false,
      signatureCondition: false,
      signatureNumber: false,
      signatureBox: false,
      constants: {
        SELLING_REGIONS,
        OPPORTUNITY_TYPES_IDS
      }
    }
  },
  methods: {
    toggleTermsAndConditionsModal (i = 0) {
      this.modal = i === 1 ? 1 : 0
      this.isModalTermsAndConditionsToggle = !this
        .isModalTermsAndConditionsToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalTermsAndConditionsToggle
      )
      if (this.modal === 1) {
        this.toggleBookMyGroupModal()
        document.body.classList.add(
          'modal-open',
          this.isModalTermsAndConditionsToggle
        )
      }

      this.checkTermConditionScroll(this.isModalTermsAndConditionsToggle)
    },
    toggleBookMyGroupModal () {
      this.isModalBookMyGroupToggle = !this.isModalBookMyGroupToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupToggle
      )

      setTimeout(() => {
        let canvas = document.querySelector('.signature-gold canvas')
        if (canvas) {
          let parentWidth = canvas.parentElement.offsetWidth
          let parentHeight = canvas.parentElement.offsetHeight
          canvas.height = parentHeight
          canvas.width = parentWidth
        }
      }, 500)
    },
    toggleBookMyGroupSuccessModal () {
      this.isModalBookMyGroupSuccessToggle = !this
        .isModalBookMyGroupSuccessToggle
      document.body.classList.toggle(
        'modal-open',
        this.isModalBookMyGroupSuccessToggle
      )
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    },
    handleSaveSignature () {
      this.signatureName = false
      this.signaturePayment = false
      this.signatureCondition = false
      this.signatureNumber = false
      this.signatureBox = false
      if (
        this.signature.accepted_conditions === false ||
        this.signature.name === '' ||
        this.signature.payment_amount === '' ||
        this.signature.number_of_guests === ''
      ) {
        this.message = 'All the fields are required.'
        if (this.signature.accepted_conditions === false) {
          this.signatureCondition = true
        }
        if (this.signature.name === '') {
          this.signatureName = true
        }
        if (this.signature.payment_amount === '') {
          this.signaturePayment = true
        }
        if (this.signature.number_of_guests === '') {
          this.signatureNumber = true
        }
        return false
      }
      if (this.$refs.signature.isEmpty()) {
        this.message = 'Please fill your signature.'
        this.signatureBox = true
        return false
      }
      this.signature.uuid = this.$route.params.uuid
      this.signature.accepted_conditions = 1
      this.signature.image = this.$refs.signature.save()
      this.disableButton = true
      this.message = null
      this.sendSignature(this.signature)
        .then(response => {
          if (response.data && response.status === 200 && response.data.status) {
            this.cleanForm()
            this.disableButton = true
            this.hasSignature = true
            this.toggleBookMyGroupSuccessModal()
            this.toggleBookMyGroupModal()
          } else {
            this.message = 'Something went wrong, please try again.'
            this.isSending = false
            this.isCompleted = true
            this.disableButton = false
          }
        })
        .catch(error => {
          const hasMessage = error && error.response && error.response.data && error.response.data.message
          this.message = hasMessage || 'Something went wrong, please try again.'
          this.isSending = false
          this.isCompleted = true
          if (error.response.data.hash) {
            this.hash = error.response.data.hash
          }
          this.disableButton = false
        })
        .finally(() => {})
    },
    clear () {
      var _this = this
      _this.$refs.signature.clear()
    },
    undo () {
      var _this = this
      _this.$refs.signature.undo()
    },
    cleanForm () {
      this.signature.id = null
      this.signature.parent = null
      this.signature.name = ''
      this.signature.last_name = ''
      this.signature.user_agent = ''
      this.signature.payment_amount = ''
      this.signature.traveler_email = ''
      this.signature.number_of_guests = ''
      this.signature.accepted_conditions = 0
      this.signature.image = ''
      this.clear()
    },
    handleInput (e, value) {
      if (value !== '' || value) {
        e.target.classList.remove('active')
      }
    }
  },
  components: {
    IconPlay,
    vueSignature
  },
  mounted () {
    // this.signature.traveler_email = this.data.data.email_owner
    //   ? this.data.data.email_owner
    //   : ''
    this.signature.parent = this.data.data.itineraries.id
      ? this.data.data.itineraries.id
      : ''

    this.getSignature(this.signature.parent)
  }
}
</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div
    id="menu"
    class="body-page fp-viewing-home body"
    :class="{ 'modal-open': isModalToggle }"
  >
    <!-- BEGIN OF site header Menu -->
    <header
      class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn hidePlease"
    >
      <!-- Begin of menu icon toggler -->
      <button
        class="navbar-toggler site-menu-icon"
        id="navMenuIcon"
        :class="{ 'menu-visible': isMenuToggle }"
        @click="toggleMenu"
        v-if="showCover"
      >
        <span
          class="menu-icon menu-icon-line"
          :class="{ 'menu-visible': isMenuToggle }"
        >
          <span
            class="text show-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            >Close</span
          >
          <span
            class="text hide-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            >Menu</span
          >
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img
                v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
                class="light-logo"
                src="/weblinks/luxury-gold/img/logo.png"
                alt="Logo"
              />
              <img
                v-else
                class="light-logo"
                src="/weblinks/luxury-gold/img/logo.png"
                alt="Logo"
              />
            </span>
          </a>
        </div>
      </div>

      <div
        class="all-menu-wrapper"
        id="navbarMenu"
        :class="{ 'menu-visible': isMenuToggle }"
      >
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a
                  class="nav-link"
                  href="#welcome"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('welcome')"
                  >Welcome <span class="sr-only">(current)</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#itinerary"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('itinerary')"
                  >Itinerary</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#inclusion"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('inclusion')"
                  >Inclusions</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#map"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('map')"
                  >Map</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#prices"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('prices')"
                  >Pricing</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#book"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('book')"
                  >Book my group</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#contact"
                  :class="{ 'menu-visible': isMenuToggle }"
                  @click.prevent="menuScrollTo('contact')"
                  >Contact Us</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main
      class="page-main main-anim main-parallax scrollpage-container"
      id="mainpage"
    >
      <div class="page-cover scrolled">
        <!-- Cover Background -->
        <div
          class="cover-bg bg-img"
          :style="[ firstOpporunityBackgroundImage != ''
              ? {
                  backgroundImage: `url('${getParsedImageUrl(
                    firstOpporunityBackgroundImage
                  )}')`
                }
              : {
                  'background-image':
                    'url(/weblinks/luxury-gold/img/bg-style-1.jpg)'
                }
          ]"
        ></div>
        <div class="cover-bg-mask bg-color"></div>
      </div>

      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black "
        data-section="home"
      >
        <div class="fullscreen-video-wrap" v-if="!showCover">
          <button
            class="button button-play"
            type="button"
            id="firstPlayVideo"
            @click="playVideo"
          ></button>
          <button
            type="button"
            class="btn btn-link animated fadeIn slow"
            id="firstSkipVideo"
            @click="skipVideo"
          >
            <div>Skip video <IconPlay /></div>
          </button>
          <div class="overlay-home"></div>
          <video
            allow="autoplay"
            preload="auto"
            playsinline
            id="videoLoop"
            class="animated fadeIn videoDesktop"
            poster="/weblinks/luxury-gold/video/video.jpg"
          >
            <source
              src="https://d319smgd3nfzy.cloudfront.net/weblink/luxury-gold/video/video.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="section-wrapper animated delay-1s slow fadeIn">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <!--This is the cover-->
                <div
                  class="hidePlease animated fadeIn slow"
                  v-show="!showCover"
                >
                  <div
                    class="cover-header-description text-shadow-all cover-main-header-description "
                  >
                    <div class="cover-slider-description">
                      <h1 class="cover-header-description-title1">
                        <i class="icon fa fa-calendar"></i>
                        <span v-if="d && d.itineraries">{{
                          d.itineraries.fromitinerary | custom-date
                        }}</span>
                        <i class="fa fa-arrow-right ml-2"></i>
                        <i class="icon fa fa-calendar"></i>
                        <span v-if="d && d.itineraries">{{
                          d.itineraries.toitinerary | custom-date
                        }}</span>
                        <span
                          class="ml-5"
                          v-if="
                            Array.isArray(d.itineraries.locations_visited) ==
                              true
                          "
                        >
                          <i class="fa fa-map-marker"></i>
                          <span
                            v-if="
                              d &&
                                d.itineraries &&
                                d.itineraries.locations_visited &&
                                Array.isArray(d.itineraries.locations_visited)
                            "
                            >{{
                              d.itineraries.locations_visited
                                | custom-join('name')
                            }}</span
                          >
                        </span>
                      </h1>
                      <div
                        class="cover-header-description-title2"
                        v-if="d && d.itineraries"
                      >
                        {{ d.itineraries.titleitinerary }}
                      </div>
                      <!--<div class="cover-header-description-title3">
                        <span v-if="d && d.properties_opportunity && d.properties_opportunity.id_opportunity_export_type">
                          <span v-if="d.properties_opportunity.id_opportunity_export_type === 2">Scheduled Groups</span>
                          <span v-if="d.properties_opportunity.id_opportunity_export_type === 18">Custom Group Quotation</span>
                        </span>
                        <span class="txt-uppercase" v-if="d && d.properties_opportunity && d.reference_number">
                          {{ d.reference_number }}
                        </span>
                      </div>-->
                    </div>
                  </div>
                  <div class="btn-trip form-group form-success-gone mb-0">
                    <button
                      id="submit-email"
                      name="submit_email"
                      class="btn-trip_main btn form-success-gone mb-0 "
                      @click="toggleCover"
                    >
                      <span class="text">VIEW YOUR LUXURY TRIP</span>
                    </button>
                  </div>
                </div>
                <!--Finish cover-->
                <!--This is Home-->
                <div
                  class="cover-header-description text-shadow-all"
                  v-show="showCover"
                >
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{
                        d.itineraries.fromitinerary | custom-date
                      }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{
                        d.itineraries.toitinerary | custom-date
                      }}</span>
                      <span
                        class="ml-5"
                        v-if="
                          Array.isArray(d.itineraries.locations_visited) == true
                        "
                      >
                        <i class="fa fa-map-marker"></i>
                        <span
                          v-if="
                            d &&
                              d.itineraries &&
                              d.itineraries.locations_visited &&
                              Array.isArray(d.itineraries.locations_visited)
                          "
                          >{{
                            d.itineraries.locations_visited
                              | custom-join('name')
                          }}</span
                        >
                      </span>
                    </h1>
                    <div
                      class="cover-header-description-title2"
                      v-if="d && d.itineraries"
                    >
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="cover-header-description-title3">
                      <span
                        v-if="
                          d &&
                            d.properties_opportunity &&
                            d.properties_opportunity.id_opportunity_export_type
                        "
                      >
                        <span
                          v-if="
                            d.properties_opportunity
                              .id_opportunity_export_type === 2
                          "
                          >Scheduled Groups</span
                        >
                        <span
                          v-if="
                            d.properties_opportunity
                              .id_opportunity_export_type === 18
                          "
                          >Custom Group Quotation</span
                        >
                      </span>
                      <span
                        class="txt-uppercase"
                        v-if="
                          d && d.properties_opportunity && d.reference_number
                        "
                      >
                        {{ d.reference_number }}
                      </span>
                    </div>
                    <a @click="scrollMeTo('welcome')"
                      ><span class="icon-arrow-down"></span
                    ></a>
                  </div>
                </div>
                <!--Finish Home-->
              </div>
            </div>
          </div>

          <footer class="section-footer scrolldown" v-show="showCover">
            <a class="down" @click="scrollMeTo('welcome')">
              <span class="icon"></span>
              <span class="txt">WELCOME</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div
        class="section fl-porto text-shadow-all"
        data-section="welcome"
        id="welcome"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div class="section-tittle paddig-container">
                <div class="cover-header-description-title2 scrolled">
                  Welcome
                </div>
              </div>
              <div
                class="title-desc anim-4 letter-a paddig-container"
                v-html="d.itineraries.letter_itinerary"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div
        class="section text-shadow-all"
        data-section="itinerary"
        id="itinerary"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">
                Itinerary
              </div>
              <div
                style="display:none;"
                class="cover-header-description-title3"
                v-if="d && d.itineraries"
              >
                {{ d.itineraries.titleitinerary }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span v-if="d && d.itineraries">{{
                  d.itineraries.fromitinerary | custom-date
                }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span v-if="d && d.itineraries">{{
                  d.itineraries.toitinerary | custom-date
                }}</span>
                <i
                  v-if="
                    d &&
                      d.itineraries &&
                      d.itineraries.locations_visited &&
                      Array.isArray(d.itineraries.locations_visited)
                  "
                  class="fa fa-map-marker"
                ></i>
                <span
                  v-if="
                    d &&
                      d.itineraries &&
                      d.itineraries.locations_visited &&
                      Array.isArray(d.itineraries.locations_visited)
                  "
                  >{{
                    d.itineraries.locations_visited | custom-join('name')
                  }}</span
                >
              </div>
            </div>
            <div class="row row-random grid-media-aside-text fade-3">
              <!-- an item -->
              <div
                class="item col col-12 col-md-6 text-left"
                v-for="(day, index) in d.itineraries.days"
                :key="index"
              >
                <div class="media-aside-text">
                  <div class="media-image">
                    <div class="media-image-content">
                      <img
                        v-if="day.url_image_1200_725"
                        :src="day.url_image_1200_725"
                      />
                      <img
                        v-if="!day.url_image_1200_725"
                        src="/weblinks/luxury-gold/img/day-img.jpg"
                      />
                    </div>
                  </div>
                  <div class="media-body">
                    <h5 class="media-day">Day {{ day.startday }}</h5>
                    <h5 class="media-title" v-html="day.title"></h5>
                    <h6 class="media-date">
                      <i class="icon fa fa-calendar color-golden mr-2"></i>
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </h6>
                    <h6
                      v-if="
                        day && day.locations && Array.isArray(day.locations)
                      "
                      class="media-location mt-1"
                    >
                      <i class="icon fa fa-map-marker color-golden mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </h6>
                    <h6
                      class="media-details"
                      data-toggle="modal"
                      data-target="#modal-fullscreen"
                      @click="dayScrollTo(index)"
                    >
                      <span class="text">DETAILS</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <!-- <div class="section fullscreen-md-off bg-level-3 no-footer" data-section="inclusion" id="inclusion" v-show="showCover"> -->
      <div
        class="section fullscreen-md-off"
        data-section="inclusion"
        id="inclusion"
        v-show="showCover"
        v-if="
          (Array.isArray(d.itineraries.highlights) &&
            d.itineraries.highlights.length > 0) |
            (Array.isArray(d.itineraries.whatsincluded) &&
              d.itineraries.whatsincluded.length > 0) |
            (Array.isArray(d.itineraries.whatsnotincluded) &&
              d.itineraries.whatsnotincluded.length > 0)
        "
      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">
                Inclusions
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div
                  class="section-info white"
                  v-if="
                    Array.isArray(d.itineraries.highlights) &&
                      d.itineraries.highlights.length > 0
                  "
                >
                  <h1>Highlights</h1>
                  <div
                    v-for="highlight in d.itineraries.highlights"
                    :key="highlight.id"
                  >
                    <h3 v-html="highlight.title"></h3>
                    <ul class="mb-4">
                      <li
                        v-for="item in highlight.items"
                        :key="item.id"
                        v-html="item.items"
                      ></li>
                    </ul>
                  </div>
                </div>

                <div
                  class="section-info white-gold  pr-4"
                  v-if="
                    Array.isArray(d.itineraries.whatsincluded) &&
                      d.itineraries.whatsincluded.length > 0
                  "
                >
                  <h1>What's Included</h1>
                  <div
                    v-for="whatsinc in d.itineraries.whatsincluded"
                    :key="whatsinc.id"
                  >
                    <h3 v-html="whatsinc.title"></h3>
                    <ul class="mb-4">
                      <li
                        v-for="item in whatsinc.items"
                        :key="item.id"
                        v-html="item.items"
                      ></li>
                    </ul>
                  </div>
                </div>

                <div
                  class="section-info blue-gold pr-4"
                  v-if="
                    Array.isArray(d.itineraries.whatsnotincluded) &&
                      d.itineraries.whatsnotincluded.length > 0
                  "
                >
                  <h1>What's Not Included</h1>
                  <div
                    v-for="whatsnotinc in d.itineraries.whatsnotincluded"
                    :key="whatsnotinc.id"
                  >
                    <h3 v-html="whatsnotinc.title"></h3>
                    <ul class="mb-4">
                      <li
                        v-for="item in whatsnotinc.items"
                        :key="item.id"
                        v-html="item.items"
                      ></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="section section-register content-white text-shadow-all"
        data-section="map"
        id="map"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Map</div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <p class="mb-5 mt-3">
                    Map route is to be used as a guide for illustration purposes
                    only, and does not represent the exact path taken.
                  </p>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of description section -->
      <div
        class="section fullscreen-md-off"
        data-section="prices"
        id="prices"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">
                Pricing
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div
                  class="section-info white white-gold"
                  v-html="d.itineraries.pricing_itinerary"
                  :class="{
                    usa: 244 == d.selling_regions[0].id,
                    'all-regions': 244 != d.selling_regions[0].id
                  }"
                ></div>
                <p class="terms">
                  View
                  <a href="#" @click.prevent="toggleTermsAndConditionsModal(0)"
                    >Terms and Conditions</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of Book your group section -->
      <div
        class="section content-white text-shadow-all"
        data-section="book"
        id="book"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info text-center">
                <div class="section-tittle">
                  <div
                    class="cover-header-description-title2 scrolled text-center"
                  >
                    Book my group
                  </div>
                </div>
                <div class="pt-4">
                  <button class="pt-4 text-center text-book-signature"
                  :disabled="data.data.request_form.properties_request_form.id_stage_supplier !== 23"
                  >
                    <span class="text-book-disabled">
                    Not activated until Quote Complete
                    </span>
                    <span class="text-book-enabled"> If you are happy with our proposal and would like to go ahead please click here.</span>
                  </button>
                  <div
                    class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                  >
                    <button
                      class="btn mt-3 btn-outline-gold form-success-gone mb-0 button-book-signature"
                      type="submit"
                      @click.prevent="toggleBookMyGroupModal"
                      :disabled="data.data.request_form.properties_request_form.id_stage_supplier !== 23"
                    >
                      <strong class="text">Book this trip</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-6 anim contact-info  fluid contact-border-left"
              >
                <div class="book-image-box">
                  <img
                    v-if="secondOpporunityBackgroundImage != ''"
                    :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`"
                    alt=""
                  />
                  <img
                    v-else
                    src="/weblinks/luxury-gold/img/bg-style-1.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section -->
      <div
        class="section text-shadow-all section-contact  content-white "
        data-section="contact"
        id="contact"
        v-show="showCover"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content paddig-container">
            <div class="row">
              <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                <div class="section-tittle">
                  <div
                    class="cover-header-description-title2 scrolled text-center"
                  >
                    Contact us
                  </div>
                </div>
                <div class="pt-4">
                  <h3
                    class="pt-4 text-center"
                    v-if="!d.firstname_owner && !d.lastname_owner"
                  >
                    Contact your Travel Advisor or call
                  </h3>
                  <h3 class="pt-4 text-center">
                    <span v-if="d.firstname_owner">{{
                      d.firstname_owner
                    }}</span>
                    <span v-if="d.lastname_owner"> {{ d.lastname_owner }}</span>
                  </h3>
                  <h3 class="pt-4 text-center">
                    <strong v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
                      >1-888-370-2736 Option {{ d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.SCHEDULED ? "1" : d.properties_opportunity.id_opportunity_export_type === constants.OPPORTUNITY_TYPES_IDS.CUSTOM ? "2" : "" }}</strong
                    >
                    <strong
                      v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.GB.id"
                      >+44 20 7620 8996</strong
                    >
                    <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.AU.id"
                      >1300 780 283</strong
                    >
                    <strong v-else-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.CA.id"
                      >1-800-346-2830</strong
                    >
                    <strong v-else>1 888 680 1241</strong>
                  </h3>
                  <p
                    class="tour_host_name"
                    v-html="d.consumer_section.tour_host_name"
                  ></p>
                  <img
                    class="tour_host_logo"
                    :src="d.consumer_section.company_logo"
                  />
                </div>
              </div>

              <div
                class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left"
              >
                <div class="contact-us-box">
                  <div class="section-tittle">
                    <div class="cover-header-description-title2 scrolled">
                      Message us Directly
                    </div>
                  </div>
                  <form @submit.prevent="sendContactForm">
                    <div class="form-group ">
                      <input
                        class="form-control-white"
                        type="text"
                        required
                        placeholder="Name"
                        v-model="name"
                        :disabled="isSending"
                      />
                    </div>
                    <div class="form-group ">
                      <input
                        class="form-control-white"
                        type="text"
                        required
                        placeholder="Email"
                        v-model="email"
                        :disabled="isSending"
                      />
                    </div>
                    <div class="form-group ">
                      <textarea
                        class="form-control-white"
                        type="text"
                        required
                        placeholder="How can we assist you with this group?"
                        cols="10"
                        rows="10"
                        v-model="description"
                        :disabled="isSending"
                      ></textarea>
                    </div>
                    <div
                      class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                    >
                      <div v-if="isCompleted" class="mr-3">{{ message }}</div>
                      <button
                        class="btn btn-outline-white-gold form-success-gone mb-0"
                        type="submit"
                        :disabled="isSending"
                      >
                        <strong class="text" v-if="!isSending">Send</strong>
                        <strong class="text" v-else>Sending</strong>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of footer section -->
      <footer v-show="showCover">
        <div class="footer-left text-shadow-all">
          <ul class="social">
            <li>
              <a @click="scrollMeTo('home')">
                <i class="icon-arrow-up"></i>
              </a>
            </li>
            <li>
              <a @click="scrollMeTo('itinerary')">
                <i class="icon fa fa-globe"></i>
              </a>
            </li>
            <li>
              <a @click="scrollMeTo('contact')">
                <i class="icon fa fa-phone"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="section-wrapper padding-footer">
          <div class="powered-by-text">
            Powered by
            <img src="/weblinks/luxury-gold/img/logo-itp.png" width="80" /> All
            rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal -- TERMS AND CONDITIONS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-terms-and-conditions-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalTermsAndConditionsToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalTermsAndConditionsToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleTermsAndConditionsModal(modal)"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 color-golden pt-4 text-center">
                Terms & Conditions
              </h3>
            </div>
            <div
              class="title-desc anim-4 paddig-container scrollable "
              v-html="d.itineraries.terms_conditions"
              @scroll="handleTCScroll"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal-- TERMS AND CONDITIONS -->

    <!-- Modal -- MODAL BOOK MY GROUP -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div class="modal-body">
            <div class="title-desc">
              <h3 class="h2 color-golden pt-4 text-center">Book my group</h3>
            </div>
            <div
              v-if="hasSignature"
              class="mx-5 mb-0 mt-4 alert alert-success"
              role="alert"
            >
              Thank you for confirming this group with us. Please Contact Us if we can assist you further.
            </div>
            <div
              class="title-desc anim-4 py-3 d-flex justify-content-center align-items-center"
            >
              <form
                @submit.prevent="handleSaveSignature"
                class="form-gold mt-0 px-5 py-0"
              >
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Your Full Name"
                    v-model="signature.name"
                    :disabled="hasSignature"
                    :class="{ active: signatureName }"
                    @blur="handleInput($event, signature.name)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="No. of seats + No. of TW & SG room type requested. E.g.: 16 pax, 7 Twins + 2 Singles"
                    v-model="signature.number_of_guests"
                    :disabled="hasSignature"
                    :class="{ active: signatureNumber }"
                    @blur="handleInput($event, signature.number_of_guests)"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control-white"
                    type="text"
                    placeholder="Deposit amount paid"
                    v-model="signature.payment_amount"
                    :disabled="hasSignature"
                    :class="{ active: signaturePayment }"
                    @blur="handleInput($event, signature.payment_amount)"
                  />
                </div>
                <div v-if="signature.user_agent === ''" :class="[ signatureBox ? 'signature-gold box-signature-div active' : 'signature-gold box-signature-div']">
                  <vueSignature
                    ref="signature"
                    :sigOption="option"
                    :w="'100%'"
                    :h="'200px'"
                  ></vueSignature>
                  <button @click="clear" class="button_clear">Clear</button>
                  <button @click="undo" class="button_undo">Undo</button>
                </div>
                <div v-else class="signature-gold">
                  <img
                    class="img-signature"
                    width="100%"
                    v-bind:src="signature.user_agent"
                  />
                </div>
                <p :class="['terms mt-2', { active: signatureCondition }, termConditionsRead ? '' : 'disabled']" v-if="!hasSignature">
                  <input
                    type="checkbox"
                    v-model="signature.accepted_conditions"
                    name=""
                    @blur="handleInput($event, signature.accepted_conditions)"
                  />
                  Accept T&Cs
                  <a
                    href="#"
                    class="color-golden"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    >click here</a
                  >
                </p>
                <p class="terms mt-2 hideTerms" v-else>
                  View
                  <a
                    href="#"
                    class="color-golden"
                    @click.prevent="toggleTermsAndConditionsModal(1)"
                    >Terms and Conditions</a
                  >
                </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <div v-if="message" class="mr-32 dangerMessage">{{ message }}</div>
                  <button
                    class="btn btn-outline-gold form-success-gone mb-0 button-book-signature"
                    type="submit"
                    :disabled="disableButton"
                  >
                    <strong class="text">Confirm</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL BOOK MY GROUP -->

    <!-- Modal -- MODAL SUCCESS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-book-my-group-success"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalBookMyGroupSuccessToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalBookMyGroupSuccessToggle"
    >
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleBookMyGroupSuccessModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog animated fadeIn">
        <div class="modal-content  ">
          <div
            class="modal-body d-flex justify-content-center align-items-center"
          >
            <div class="title-desc">
              <img
                class="success-img pt-4"
                src="/weblinks/luxury-gold/img/success-img.png"
              />
              <h3 class="h2 color-golden pt-1 text-center">Success</h3>
              <div class="anim-4 text-center pb-4">
                <p>Your information was sent.</p>
                  <p>A
                    <strong class="color-golden">Group Specialist</strong>
                    will make contact with you to<br> re-confirm details by the end of the next business day.
                  </p>
                <div
                  class="form-group form-success-gone mb-0 d-flex justify-content-center align-items-center"
                >
                  <button
                    class="btn btn-outline-gold form-success-gone mb-0"
                    type="submit"
                    @click="toggleBookMyGroupSuccessModal"
                  >
                    <strong class="text">Ok</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal -- MODAL SUCCESS -->

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle"
    >
      <div class="section-header">
        <div class="label-logo">
          <img
            v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id"
            class="light-logo"
            src="/weblinks/luxury-gold/img/logo.png"
            alt="Logo"
          />
          <img
            v-else
            class="light-logo"
            src="/weblinks/luxury-gold/img/logo.png"
            alt="Logo"
          />
        </div>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days"
              :key="index"
            >
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img
                    v-if="day.url_image_1600_900"
                    :src="day.url_image_1600_900"
                  />
                  <img
                    v-if="!day.url_image_1600_900"
                    src="/weblinks/luxury-gold/img/day-img.jpg"
                  />
                </div>
                <div class="col-md-6 section-text">
                  <div class="align-vcenter">
                    <h1>Day {{ index + 1 }}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p
                      class="location mt-2"
                      v-if="
                        day && day.locations && Array.isArray(day.locations)
                      "
                    >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      v-html="day.textday[0].textday"
                    ></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer
                    class="section-footer scrolldownDay nextday"
                    v-if="index != Object.keys(d.itineraries.days).length - 1"
                  >
                    <a class="down" @click="scrollMeDay(`day${index + 1}`)">
                      <span class="txt"
                        >DAY {{ Number(day.startday) + 1 }}</span
                      >
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal Fullscreen -- DAYS-->
  </div>
</template>
